import script from "./BottomSheetGarage.vue?vue&type=script&setup=true&lang=ts"
export * from "./BottomSheetGarage.vue?vue&type=script&setup=true&lang=ts"

import "./BottomSheetGarage.vue?vue&type=style&index=0&id=02b82163&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-02b82163"]])

export default __exports__